import constants from "./constants";
import createAction from "sagas/createAction";

const actions = {
  GetContactInfo: (token, adAccountId) => createAction(constants.GET_CONTACT_INFO, { token, adAccountId }),
};

export default actions;
